"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withDraggable = void 0;
const tslib_1 = require("tslib");
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const react_dnd_1 = require("react-dnd");
const react_dnd_html5_backend_1 = require("react-dnd-html5-backend");
const withFileSystemContext_1 = require("../withFileSystemContext");
const lib_1 = require("../../../lib");
function withDraggable(type) {
    return function (WrappedComponent) {
        const Draggable = (props) => {
            const { connectDragPreview } = props, rest = (0, tslib_1.__rest)(props, ["connectDragPreview"]);
            (0, react_1.useEffect)(() => {
                connectDragPreview((0, react_dnd_html5_backend_1.getEmptyImage)(), {
                    captureDraggingState: true,
                });
            }, []);
            return (0, jsx_runtime_1.jsx)(WrappedComponent, Object.assign({}, rest), void 0);
        };
        return (0, lib_1.compose)((0, withFileSystemContext_1.withFileSystemContext)((context) => ({ context })), (0, react_dnd_1.DragSource)(type, {
            beginDrag(props) {
                props.context.setState((state) => (Object.assign(Object.assign({}, state), { isDragging: true })));
                return {
                    type,
                    props,
                    item: props.item,
                };
            },
            endDrag(props) {
                props.context.setState((state) => (Object.assign(Object.assign({}, state), { isDragging: false })));
            },
        }, (connect, monitor) => ({
            connectDragSource: connect.dragSource(),
            isDragging: monitor.isDragging(),
            connectDragPreview: connect.dragPreview(),
        })))(Draggable);
    };
}
exports.withDraggable = withDraggable;
//# sourceMappingURL=withDraggable.js.map